export default "__VITE_ASSET__oAIHv$pY__"